var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalenderTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7008_29198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.5313C6.10935 14.5313 4.74993 14.1189 3.59365 13.3463C2.43737 12.5737 1.53615 11.4755 1.00398 10.1907C0.471797 8.90595 0.332554 7.4922 0.603857 6.12827C0.875159 4.76435 1.54482 3.5115 2.52816 2.52816C3.5115 1.54482 4.76435 0.875159 6.12827 0.603857C7.4922 0.332554 8.90595 0.471797 10.1907 1.00398C11.4755 1.53615 12.5737 2.43737 13.3463 3.59365C14.1189 4.74993 14.5313 6.10935 14.5313 7.5C14.5313 9.36481 13.7905 11.1532 12.4718 12.4718C11.1532 13.7905 9.36481 14.5313 7.5 14.5313ZM7.5 1.40625C6.29477 1.40625 5.11661 1.76365 4.1145 2.43324C3.11239 3.10282 2.33133 4.05454 1.87011 5.16803C1.40889 6.28151 1.28821 7.50676 1.52334 8.68884C1.75847 9.87091 2.33885 10.9567 3.19107 11.8089C4.0433 12.6612 5.1291 13.2415 6.31117 13.4767C7.49324 13.7118 8.71849 13.5911 9.83198 13.1299C10.9455 12.6687 11.8972 11.8876 12.5668 10.8855C13.2364 9.8834 13.5938 8.70523 13.5938 7.5C13.5938 5.88384 12.9517 4.33387 11.8089 3.19107C10.6661 2.04827 9.11617 1.40625 7.5 1.40625Z",
    fill: "#101820"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.48751 10.1531L7.1672 7.83281C7.12375 7.78901 7.08938 7.73707 7.06605 7.67996C7.04273 7.62285 7.0309 7.56169 7.03126 7.5V3.75H7.96876V7.30781L10.1531 9.4875L9.48751 10.1531Z",
    fill: "#101820"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7008_29198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderTimeIcon);
export default __webpack_public_path__ + "static/media/calender_time_icon.bcea0a9f00e84c5d9cbeb22951943991.svg";
export { ForwardRef as ReactComponent };